import React from "react";
import Navbar from "../components/homepage/Navbar";
import Footer from "../components/homepage/Footer";
import Construction from "../components/Houses/construction";

const constructionPage = () => {
  return (
    <div>
      <Navbar />
      <Construction />
      <Footer />
    </div>
  );
};

export default constructionPage;
